import { render, staticRenderFns } from "./product_mobile.vue?vue&type=template&id=14fc104b&scoped=true&"
import script from "./product_mobile.vue?vue&type=script&lang=js&"
export * from "./product_mobile.vue?vue&type=script&lang=js&"
import style0 from "./product_mobile.vue?vue&type=style&index=0&id=14fc104b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fc104b",
  null
  
)

export default component.exports